import React from "react";

export const Cart = (): JSX.Element => {
  return (
    <svg viewBox="0 0 13 12" xmlns="http://www.w3.org/2000/svg">
      <g fill="currentColor">
        <path
          d="M9.49367089,9.05210093 C8.70277507,9.05210093 8.05063291,9.69036773 8.05063291,10.4951389 C8.05063291,11.2860347 8.68889971,11.9381769 9.49367089,11.9381769 C10.2845667,11.9381769 10.9367089,11.2999101 10.9367089,10.4951389 C10.9228335,9.7042431 10.2845667,9.05210093 9.49367089,9.05210093 Z"
          id="Path"
        ></path>
        <path
          d="M12.1449943,2.13215794 C12.1166843,2.13215794 12.0742193,2.11807461 12.0317543,2.11807461 L3.11410111,2.11807461 L2.97255106,1.17449175 C2.88762103,0.554825386 2.34973084,0.090075617 1.71275561,0.090075617 L0.566200203,0.090075617 C0.254790091,0.090075617 0,0.343575491 0,0.653408671 C0,0.963241851 0.254790091,1.21674172 0.566200203,1.21674172 L1.71275561,1.21674172 C1.78353064,1.21674172 1.84015066,1.27307503 1.85430566,1.34349166 L2.73191598,7.28665538 C2.84515602,8.03307168 3.49628625,8.59640473 4.26065652,8.59640473 L10.1491386,8.59640473 C10.8851989,8.59640473 11.5221741,8.07532166 11.6778792,7.35707201 L12.5979545,2.77999095 C12.6545745,2.4842411 12.4564045,2.18849124 12.1449943,2.13215794 Z"
          id="Path"
        ></path>
        <path
          d="M5.92203751,10.4323981 C5.89363227,9.66556635 5.24031175,9.05210093 4.45916765,9.05210093 C3.6354157,9.09392812 3.01050042,9.76316312 3.03890566,10.5578797 C3.0673109,11.3247115 3.7064288,11.9381769 4.48757289,11.9381769 L4.51597813,11.9381769 C5.32552747,11.8963497 5.96464536,11.2271147 5.92203751,10.4323981 Z"
          id="Path"
        ></path>
      </g>
    </svg>
  );
};
